import { postText, requireUrl } from "../http.js";

export function createZoomAdapter(config) {
    return {
        async connect() {
            requireUrl(config.endpoint, "Zoom CART URL");
            return true;
        },
        async test() {
            return this.send("");
        },
        async send(text = "") {
            return postText(requireUrl(config.endpoint, "Zoom CART URL"), text, {}, true);
        },
        async clear() {
            return this.send("");
        },
        async disconnect() {
            return true;
        },
    };
}
